<template>
  <div
    id="center"
    style="min-height: 559px;"
  >
    <div id="north">
      <header-info cur="4"></header-info>
    </div>
    <div
      id="content"
      class="content"
    >
      <div
        class="login"
        id="state_login"
        v-if="step==1"
      >
        <div class="login_title">实验管理平台注册</div>
        <form
          class="login_form"
          id="regForm"
        >
          <div class="login_item">
            <input
              class="ipt"
              type="text"
              v-model="formInfo.mobile"
              placeholder="手机号"
              required=""
              autocomplete="off"
              maxlength="11"
            >
          </div>
          <div class="login_item item-verify hide">
            <input
              v-model="verifyCode.code"
              class="ipt verify"
              type="text"
              autocomplete="off"
              placeholder="输入图形验证码"
              required=""
            >
            <span
              @click="getVerifyCode"
              class="verify-code"
              title="看不清，换一个"
            ><img :src="formatImage(verify.path)"></span>
          </div>
          <div class="login_item item-verify hide">
            <input
              v-model="formInfo.mobile_code"
              class="ipt verify"
              type="text"
              autocomplete="off"
              placeholder="输入短信验证码"
              required=""
            >
            <span
              class="code"
              @click="sendMsg"
              :style="isMsgSend ? 'background:#ccc' : ''"
            >
              {{ this.isMsgSend ? '' + this.seconds + '秒' : '获取验证码' }}
            </span>
          </div>

        </form>
        <div
          class="login_btn"
          id="loginBut"
          @click="nextStep"
        >下一步</div>
        <div class="agreement">
          <input
            type="radio"
            v-model="isAgree"
            value="1"
          >
          <p>我已经认真阅读并同意此网站的<span @click="showAgreementWindow">《注册协议》</span>和<span @click="showPrivacyAgreementWindow">《隐私协议》</span></p>
        </div>
      </div>
      <div
        class="login"
        id="state_login"
        v-if="step==2"
      >
        <div class="login_title">实验管理平台注册</div>
        <form
          class="login_form"
          id="regForm"
        >
          <div class="login_item">
            <input
              class="ipt"
              type="text"
              v-model="formInfo.username"
              placeholder="用户名为4-16位数字、字母组合"
              required=""
              autocomplete="off"
            >
          </div>
          <div class="login_item">
            <input
              class="ipt"
              type="text"
              v-model="formInfo.name"
              placeholder="姓名为2-10位中文或4-20位字母"
              required=""
              autocomplete="off"
            >
          </div>
          <div class="login_item">
            <input
              class="ipt"
              type="text"
              v-model="formInfo.emailInfo"
              placeholder="输入邮箱，找回密码唯一凭证"
              required=""
              autocomplete="off"
            >
          </div>
          <div class="login_item">
            <input
              class="ipt"
              type="password"
              v-model="formInfo.password1"
              placeholder="输入密码"
              required=""
            >
          </div>
          <div class="login_item">
            <input
              class="ipt"
              type="password"
              v-model="formInfo.password2"
              placeholder="再次输入密码"
              required=""
            >
          </div>
          <div class="login_item choice">
            <select
              v-model="formInfo.role"
              @change="onRoleChange"
            >
              <option value="">请选择身份</option>
              <option value="11">教师</option>
              <option value="12">学生</option>
            </select>
          </div>
          <div class="login_item choice">
            <select
              v-model="formInfo.province"
              @change="searchSchool(formInfo.province)"
            >
              <option
                :value="key"
                v-for="(val, key) in provinceData"
                :key="key"
              >{{ val }}</option>
            </select>
          </div>
          <div class="login_item choice">
            <select
              v-model="formInfo.school_id"
              @change="searchAcademy(formInfo.school_id)"
            >
              <option value="">请选择学校</option>
              <option
                :value="item.id"
                v-for="item in schoolData"
                :key="item.id"
              >{{item.title}}</option>
            </select>
          </div>
          <div class="login_item choice">
            <select
              v-model="formInfo.academy_id"
              @change="searchMajor(formInfo.academy_id)"
            >
              <option value="">请选择学院</option>
              <option
                :value="item.id"
                v-for="item in academyData"
                :key="item.id"
              >{{ item.title }}
              </option>
            </select>
          </div>
          <div
            class="login_item choice"
            v-show="formInfo.role == 12"
          >
            <select v-model="formInfo.major_id">
              <option value="">请选择专业</option>
              <option
                :value="item.id"
                v-for="item in majorData"
                :key="item.id"
              >{{ item.title }}</option>
            </select>
          </div>
          <div
            class="login_item"
            v-show="formInfo.role == 12"
          >
            <input
              class="ipt"
              type="text"
              v-model="formInfo.s_no"
              placeholder="请输入学号"
              autocomplete="off"
              maxlength="25"
            >
          </div>
        </form>
        <div class="login_remenber_box clearfix">
          <div class="login_resigter">
            <router-link to="/login">已有账号，去登陆</router-link>
          </div>
        </div>
        <div
          class="login_btn"
          id="loginBut"
          @click="registerBtn"
        >注册</div>
      </div>
    </div>
    <div id="south">
      <footer-info></footer-info>
      <div id="footer"></div>
    </div>
    <!-- 注册协议 -->
    <div
      class="form_overlay"
      :style="classShowAgreementWindow"
    >
      <div class="form_overlay_bg"></div>
      <div class="form_panel">
        <div class="form_title">注册协议</div>
        <div class="form_content">
          <p>
            您现在正在申请成为本网站的注册用户。在注册前，敬请您阅读本协议项下的全部条款并完全同意后才可以进行注册。
          </p>
          <p class="title">
            第一条 用户资格
          </p>
          <p>
            在您承诺完全同意本服务条款并在本网站完成注册程序后，即可成为本网站注册用户，享受本网站为您提供的学习内容和服务。
          </p>
          <p class="title">
            第二条 用户权限
          </p>
          <p>
            注册用户均有义务遵守本规定及其它网络服务的协议、规定、程序及惯例。
          </p>
          <p class="title">
            第三条 用户资料
          </p>
          <p>
            3.1 为了使我们能够更好地为您提供服务，请您提供详尽准确的个人资料，如更改请及时更新，提供虚假资料所造成的后果由会员承担；
          </p>
          <p>
            3.2 用户有责任保管好自己的注册密码并定期修改避免造成损失，由于用户疏忽所造成的损失由本人自行承担。用户应当对以其用户账号在本网站上进行的所有活动和事件负法律责任。
          </p>
          <p class="title">
            第四条 使用规则
          </p>
          <p>
            4.1 用户在使用本网站的过程中，必须遵循国家的相关法律法规，不得发布危害国家安全、色情、暴力等非法内容；也不得利用本网站平台发布含有虚假、有害、胁迫、侵害他人隐私、骚扰、侵害、中伤、粗俗、或其它道德上令人反感的内容。
          </p>
          <p>
            4.2 本网站可依其合理判断，对违反有关法律法规或本协议约定或侵犯、妨害、威胁任何人权利或安全的内容及假冒他人的行为，有权停止传输或删除任何前述内容，并有权依其自行判断对违反本条款的任何用户采取适当的法律行动，包括但不限于：删除具有违法性、侵权性、不当性等内容，阻止其使用本网站全部或部分服务, 并且依据法律法规保存有关信息并向有关部门报告等。
          </p>
          <p>
            4.3 本网站不保证用户通过本网站所发布的内容的正确性和完整性。在任何情况下, 本网站均不对任何内容负责，包括但不限于任何内容发生任何错误或纰漏以及衍生的任何损失或损害。
          </p>
          <p>
            4.4 用户通过本网站网络服务所发布的任何内容并不反映本网站的观点或政策，本网站对此不承担任何责任。用户须对上述内容的真实性、合法性、无害性、有效性等全权负责，与用户所发布信息相关的任何法律责任由用户自行承担，与本网站无关。
          </p>
          <p class="title">
            第五条 版权声明
          </p>
          <p>
            本网站提供的网络服务中包含的任何内容的所有权受法律的保护，未经相关权利人同意，上述资料均不得在任何媒体直接或间接发布、播放、出于播放或发布目的而改写或再发行，或者被用于其他任何商业目的。
          </p>
          <p class="title">
            第六条 隐私保护
          </p>
          <p>
            本网站保证不对外公开或向第三方提供用户的注册资料及用户在使用网络服务时存储在本网站内的内容，但下列情况除外：
          </p>
          <p>
            1、事先获得用户的书面明确授权；
          </p>
          <p>
            2、根据有关的法律法规要求；
          </p>
          <p>
            3、按照相关政府主管部门的要求；
          </p>
          <p>
            4、为维护社会公众的利益；
          </p>
          <p>
            5、为维护本网站的合法权益；
          </p>
          <p class="title">
            第七条 协议更新
          </p>
          <p>
            本《协议》可由本网站随时更新, 更新后的协议条款一旦公布即代替原协议条款, 恕不再另行通知, 用户可在本网站查阅最新版协议条款。在本网站修改《协议》条款后, 如果用户不接受修改后的条款, 请立即停止使用本网站提供的内容和服务, 继续使用的用户将被视为已接受修改后的协议。
          </p>
          <p class="title">
            第八条 附则
          </p>
          <p>
            8.1 本协议的订立、执行和解释及争议的解决均应适用中华人民共和国法律。
          </p>
          <p>
            8.2 如本协议中的任何条款无论因何种原因完全或部分无效或不具有执行力，本协议的其余条款仍应有效并且有约束力。
          </p>
          <p>
            8.3 本协议解释权及修订权归本网站所有。
          </p>
        </div>
        <div class="form_control">
          <a
            href="javascript:;"
            class="button"
            @click="classShowAgreementWindow={}"
          >确定</a>
        </div>
      </div>
    </div>
    <!-- 隐私协议 -->
    <div
      class="form_overlay"
      :style="privacyAgreementWindow"
    >
      <div class="form_overlay_bg"></div>
      <div class="form_panel">
        <div class="form_title">隐私协议</div>
        <div class="form_content">
          <p class="introduction">
            引言
          </p>
          <p>
            我们非常重视用户的隐私。您在使用我们的服务时，我们可能会收集和使用您的相关信息。我们希望通过本《隐私政策》向您说明，在使用我们的服务时，我们如何收集、使用、储存和分享这些信息，以及我们为您提供的访问、更新、控制和保护这些信息的方式。本《隐私政策》与您所使用的网站服务息息相关，希望您仔细阅读，在需要时，按照本《隐私政策》的指引，作出您认为适当的选择。本《隐私政策》中涉及的相关技术词汇，我们会尽量以简明扼要的表述，并提供进一步说明的链接，以便您的理解。
          </p>

          <p>
            您使用或继续使用我们的服务，即意味着同意我们按照本《隐私政策》收集、使用、储存和分享您的相关信息。
          </p>

          <p class="title">
            我们可能收集的信息
          </p>
          <p>
            您使用服务时我们可能收集如下信息：
          </p>

          <p>
            1.您提供的信息
          </p>

          <p>
            您在注册账户或使用我们的服务时，向我们提供的相关个人信息，例如电话号码、电子邮件等；
          </p>

          <p>
            您通过我们的服务向其他方提供的共享信息，以及您使用我们的服务时所储存的信息。
          </p>

          <p>
            2.其他方分享的您的信息
          </p>

          <p>
            其他方使用我们的服务时所提供有关您的共享信息。
          </p>

          <p class="title">
            我们获取的您的信息
          </p>
          <p>
            我们提供服务时，可能会收集、储存和使用下列与您有关的信息。如果您不提供相关信息，可能无法注册成为我们的用户或无法享受我们提供的某些服务，或者无法达到相关服务拟达到的效果。
          </p>

          <p>
            1.日志信息，指您使用我们的服务时，系统可能通过cookies、web beacon或其他方式自动采集的技术信息，包括：
          </p>

          <p>
            ▪ 设备或软件信息，例如您的移动设备、网页浏览器或用于接入我们服务的其他程序所提供的配置信息、您的IP地址和移动设备所用的版本和设备识别码；
          </p>

          <p>
            ▪ 在使用我们服务时搜索或浏览的信息，例如您使用的网页搜索词语、访问的社交媒体页面url地址，以及您在使用我们服务时浏览或要求提供的其他信息和内容详情；
          </p>

          <p>
            ▪ 您通过我们的服务分享的内容所包含的信息（元数据），例如拍摄或上传的共享照片或录像的日期、时间或地点等。
          </p>

          <p>
            2.位置信息，指您开启设备定位功能并使用我们基于位置提供的相关服务时，收集的有关您位置的信息，包括
          </p>

          <p>
            ▪ 您通过具有定位功能的移动设备使用我们的服务时，通过GPS或WiFi等方式收集的您的地理位置信息；
          </p>

          <p>
            ▪ 您或其他用户提供的包含您所处地理位置的实时信息，例如您提供的账户信息中包含的您所在地区信息，您或其他人上传的显示您当前或曾经所处地理位置的共享信息，您或其他人共享的照片包含的地理标记信息；
          </p>

          <p>
            ▪ 您可以通过关闭定位功能，停止对您的地理位置信息的收集。
          </p>

          <p class="title">
            我们可能如何使用信息
          </p>
          <p>
            我们可能将在向您提供服务的过程之中所收集的信息用作下列用途：
          </p>

          <p>
            ▪ 向您提供服务；
          </p>

          <p>
            ▪ 在我们提供服务时，用于身份验证、客户服务、安全防范、诈骗监测、存档和备份用途，确保我们向您提供的产品和服务的安全性；
          </p>

          <p>
            ▪ 帮助我们设计新服务，改善我们现有服务；
          </p>

          <p>
            ▪ 使我们更加了解您如何接入和使用我们的服务，从而针对性地回应您的个性化需求，例如语言设定、位置设定、个性化的帮助服务和指示，或对您和其他用户作出其他方面的回应；
          </p>

          <p>
            ▪ 向您提供与您更加相关的广告以替代普遍投放的广告；
          </p>

          <p>
            ▪ 评估我们服务中的广告和其他促销及推广活动的效果，并加以改善；
          </p>

          <p>
            ▪ 软件认证或管理软件升级；
          </p>

          <p>
            ▪ 让您参与有关我们产品和服务的调查。
          </p>

          <p>
            为了让您有更好的体验、改善我们的服务或您同意的其他用途，在符合相关法律法规的前提下，我们可能将通过某一项服务所收集的信息，以汇集信息或者个性化的方式，用于我们的其他服务。例如，在您使用我们的一项服务时所收集的信息，可能在另一服务中用于向您提供特定内容，或向您展示与您相关的、非普遍推送的信息。如果我们在相关服务中提供了相应选项，您也可以授权我们将该服务所提供和储存的信息用于我们的其他服务。
          </p>

          <p>
            您如何访问和控制自己的个人信息
          </p>
          <p>
            我们将尽一切可能采取适当的技术手段，保证您可以访问、更新和更正自己的注册信息或使用我们的服务时提供的其他个人信息。在访问、更新、更正和删除前述信息时，我们可能会要求您进行身份验证，以保障账户安全。
          </p>

          <p class="title">
            我们可能分享的信息
          </p>
          <p>
            我们以及我们的关联公司，可能将您的个人信息与我们的关联公司、合作伙伴及第三方服务供应商、承包商及代理（例如代表我们发出电子邮件或推送通知的通讯服务提供商、为我们提供位置数据的地图服务供应商）分享（他们可能并非位于您所在的法域），用作下列用途：
          </p>

          <p>
            ▪ 向您提供我们的服务；
          </p>

          <p>
            ▪ 实现“我们可能如何使用信息”部分所述目的；
          </p>

          <p>
            ▪ 履行我们在本《隐私政策》中的义务和行使我们的权利；
          </p>

          <p>
            ▪ 理解、维护和改善我们的服务。
          </p>

          <p>
            如我们或我们的关联公司与任何上述第三方分享您的个人信息，我们将努力确保该等第三方在使用您的个人信息时遵守本《隐私政策》及我们要求其遵守的其他适当的保密和安全措施。
          </p>

          <p>
            随着我们业务的持续发展，我们以及我们的关联公司有可能进行合并、收购、资产转让或类似的交易，您的个人信息有可能作为此类交易的一部分而被转移。我们将在转移前通知您。
          </p>

          <p>
            我们或我们的关联公司还可能为以下需要而保留、保存或披露您的个人信息：
          </p>

          <p>
            ▪ 遵守适用的法律法规；
          </p>

          <p>
            ▪ 遵守法院命令或其他法律程序的规定；
          </p>

          <p>
            ▪ 遵守相关政府机关的要求；
          </p>

          <p>
            ▪ 为遵守适用的法律法规、维护社会公共利益，或保护我们的客户、我们或我们的集团公司、其他用户或雇员的人身和财产安全或合法权益所合理必需的用途。
          </p>

          <p class="title">
            信息安全
          </p>
          <p>
            我们仅在本《隐私政策》所述目的所必需的期间和法律法规要求的时限内保留您的个人信息。
          </p>

          <p>
            我们使用各种安全技术和程序，以防信息的丢失、不当使用、未经授权阅览或披露。例如，在某些服务中，我们将利用加密技术来保护您提供的个人信息。但请您理解，由于技术的限制以及可能存在的各种恶意手段，在互联网行业，即便竭尽所能加强安全措施，也不可能始终保证信息百分之百的安全。您需要了解，您接入我们的服务所用的系统和通讯网络，有可能因我们可控范围外的因素而出现问题。
          </p>

          <p class="title">
            您分享的信息
          </p>
          <p>
            我们的多项服务，可让您不仅与自己的社交网络，也与使用该服务的所有用户公开分享您的相关信息，例如，您在我们的服务中所上传或发布的信息（包括您公开的个人信息、您建立的名单）、您对其他人上传或发布的信息作出的回应，以及包括与这些信息有关的位置数据和日志信息。使用我们服务的其他用户也有可能分享与您有关的信息（包括位置数据和日志信息）。
          </p>

          <p>
            因此，请您谨慎考虑通过我们的服务上传、发布和交流的信息内容。在一些情况下，您可通过我们某些服务的隐私设定来控制有权浏览您共享信息的用户范围。如要求从我们的服务中删除您的相关信息，请通过该等特别服务条款提供的方式操作。
          </p>

          <p class="title">
            您分享的敏感个人信息
          </p>
          <p>
            某些个人信息因其特殊性可能被认为是敏感个人信息，例如您的种族、宗教、个人健康和医疗信息等。相比其他个人信息，敏感个人信息受到更加严格的保护。
          </p>

          <p>
            请注意，您在使用我们的服务时所提供、上传或发布的内容和信息（例如有关您社交活动的照片等信息），可能会泄露您的敏感个人信息。您需要谨慎地考虑，是否在使用我们的服务时披露相关敏感个人信息。
          </p>

          <p>
            您同意按本《隐私政策》所述的目的和方式来处理您的敏感个人信息。
          </p>

          <p class="title">
            我们可能如何收集信息
          </p>
          <p>
            我们或我们的第三方合作伙伴，可能通过cookies收集和使用您的信息，并将该等信息储存为日志信息。
          </p>

          <p>
            我们使用自己的cookies，目的是为您提供更个性化的用户体验和服务，并用于以下用途：
          </p>

          <p>
            记住您的身份。例如：cookies有助于我们辨认您作为我们的注册用户的身份，或保存您向我们提供的有关您的喜好或其他信息；
          </p>

          <p>
            分析您使用我们服务的情况。例如，我们可利用cookies来了解您使用我们的服务进行什么活动，或哪些网页或服务最受您的欢迎；
          </p>

          <p>
            广告优化。Cookies有助于我们根据您的信息，向您提供与您相关的广告而非进行普遍的广告投放。
          </p>

          <p>
            我们为上述目的使用cookies的同时，可能将通过cookies收集的非个人身份信息，经统计加工后提供给广告商或其他合作伙伴，用于分析用户如何使用我们的服务，并用于广告服务。
          </p>

          <p>
            我们的产品和服务上可能会有广告商或其他合作方放置的cookies。这些cookies可能会收集与您相关的非个人身份信息，以用于分析用户如何使用该等服务、向您发送您可能感兴趣的广告，或用于评估广告服务的效果。这些第三方cookies收集和使用该等信息，不受本《隐私政策》约束，而是受相关使用者的隐私政策约束，我们不对第三方的cookies承担责任。
          </p>

          <p>
            您可以通过浏览器设置拒绝或管理cookies。但请注意，如果停用cookies，您有可能无法享受最佳的服务体验，某些服务也可能无法正常使用。同时，您还会收到同样数量的广告，但这些广告与您的相关性会降低。
          </p>

          <p class="title">
            我们可能向您发送的邮件和信息
          </p>
          <p>
            邮件和信息推送
          </p>

          <p>
            您在使用我们的服务时，我们可能使用您的信息向您的设备发送电子邮件、新闻或推送通知。如您不希望收到这些信息，可以按照我们的相关提示，在设备上选择取消订阅。&nbsp;
          </p>
          <p class="title">
            与服务有关的公告
          </p>

          <p>
            我们可能在必要时（例如因系统维护而暂停某一项服务时）向您发出与服务有关的公告。您可能无法取消这些与服务有关、性质不属于推广的公告。
          </p>

          <p class="title">
            隐私政策的适用例外
          </p>
          <p>
            我们的服务可能包括或链接至第三方提供的社交媒体或其他服务（包括网站）。例如：&nbsp;
          </p>
          <p>
            您利用 “分享”键将某些内容分享到我们的服务，或您利用第三方连线服务登录我们的服务。这些功能可能会收集您的相关信息（包括您的日志信息），并可能在您的电脑装置cookies，从而正常运行上述功能；
          </p>

          <p>
            我们通过广告或我们服务的其他方式向您提供链接，使您可以接入第三方的服务或网站。
          </p>

          <p>
            该等第三方社交媒体或其他服务可能由相关的第三方或我们运营。您使用该等第三方的社交媒体服务或其他服务（包括您向该等第三方提供的任何个人信息），须受该第三方的服务条款及隐私政策（而非本《隐私政策》）约束，您需要仔细阅读其条款。本《隐私政策》仅适用于我们所收集的信息，并不适用于任何第三方提供的服务或第三方的信息使用规则，我们对任何第三方使用由您提供的信息不承担任何责任。
          </p>

          <p class="title">
            未成年人使用我们的服务
          </p>
          <p>
            我们鼓励父母或监护人指导未满十八岁的未成年人使用我们的服务。我们建议未成年人鼓励他们的父母或监护人阅读本《隐私政策》，并建议未成年人在提交的个人信息之前寻求父母或监护人的同意和指导。
          </p>

          <p class="title">
            隐私政策的适用范围
          </p>
          <p>
            除某些特定服务外，我们所有的服务均适用本《隐私政策》。这些特定服务将适用特定的隐私政策。针对某些特定服务的特定隐私政策，将更具体地说明我们在该等服务中如何使用您的信息。该特定服务的隐私政策构成本《隐私政策》的一部分。如相关特定服务的隐私政策与本《隐私政策》有不一致之处，适用该特定服务的隐私政策。
          </p>

          <p class="title">
            请您注意，本《隐私政策》不适用于以下情况：
          </p>

          <p>
            ▪ 通过我们的服务而接入的第三方服务（包括任何第三方网站）收集的信息；
          </p>
          <p>
            ▪ 通过在我们服务中进行广告服务的其他公司或机构所收集的信息。
          </p>

          <p class="title">
            变更
          </p>
          <p>
            我们可能适时修订本《隐私政策》的条款，该等修订构成本《隐私政策》的一部分。如该等修订造成您在本《隐私政策》下权利的实质减少，我们将在修订生效前通过在主页上显著位置提示或向您发送电子邮件或以其他方式通知您。在该种情况下，若您继续使用我们的服务，即表示同意受经修订的本《隐私政策》的约束。
          </p>

        </div>
        <div class="form_control">
          <a
            href="javascript:;"
            class="button"
            @click="privacyAgreementWindow={}"
          >确定</a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import HeaderInfo from '../../../components/HeaderInfo'
import FooterInfo from '../../../components/FooterInfo'
import { uuid } from 'vue-uuid'
export default {
  metaInfo: {
    meta: [
      { name: 'keywords', content: '虚拟仿真,实验,实验项目,本科,专科' }
    ]
  },
  // 可用组件的哈希表
  components: {
    HeaderInfo,
    FooterInfo
  },
  // 接收传值
  props: {},
  // 数据对象
  data() {
    return {
      client_id: '',
      schoolData: [],
      academyData: [],
      majorData: [],
      formInfo: {
        mobile_code: '',
        role: '',
        username: '',
        name: '',
        mobile: '',
        emailInfo: '',
        password1: '',
        password2: '',
        province: '36',
        school_id: '',
        academy_id: '',
        major_id: '',
        s_no: '',
        mobile_status: '1'
      },
      verifyCode: {
        code: '',
        smsCode: ''
      },
      verify: {
        path: '',
        code: '',
        show: false
      },
      step: 1,
      smsVerifyCode: '',
      isMsgSend: false,
      interval: null,
      seconds: 0,
      isAgree: 0,
      classShowAgreementWindow: {},
      privacyAgreementWindow: {}
    }
  },
  // 事件处理器
  methods: {
    showAgreementWindow() {
      this.classShowAgreementWindow = {
        visibility: 'visible'
      }
    },
    showPrivacyAgreementWindow() {
      this.privacyAgreementWindow = {
        visibility: 'visible'
      }
    },
    onRoleChange() {
      this.formInfo.major_id = ''
      this.formInfo.s_no = ''
    },
    async searchSchool(province) {
      await this.$http.get('/allowany/school/', {
        params: {
          page: 1,
          size: 1000,
          status: 1,
          province: province
        }
      }).then((data) => {
        this.schoolData = data.results
        this.formInfo.school_id = ''
        this.formInfo.academy_id = ''
        this.formInfo.major_id = ''
      })
    },
    async searchAcademy(schoolId) {
      await this.$http.get('/allowany/academy/', {
        params: {
          page: 1,
          size: 1000,
          status: 1,
          school_id: schoolId
        }
      }).then((data) => {
        this.academyData = data.results
        this.formInfo.academy_id = ''
        this.formInfo.major_id = ''
      })
    },
    async searchMajor(academyId) {
      await this.$http.get('/allowany/major/', {
        params: {
          page: 1,
          size: 1000,
          status: 1,
          academy_id: academyId
        }
      }).then((data) => {
        this.majorData = data.results
        this.formInfo.major_id = ''
      })
    },
    async registerBtn() {
      var username = /^[a-zA-Z][a-zA-Z0-9]{3,15}$/ // 校验用户名
      var name = /^[\u4e00-\u9fa5]{2,10}$|^[a-zA-Z]{4,20}$/ // 校验姓名
      var email = /^[A-Za-z0-9\u4e00-\u9fa5]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/ // 校验邮箱
      var testPassword = /^(?![a-zA-Z]+$)(?![A-Z0-9]+$)(?![A-Z\W_!@#$%^&*`~()-+=]+$)(?![a-z0-9]+$)(?![a-z\W_!@#$%^&*`~()-+=]+$)(?![0-9\W_!@#$%^&*`~()-+=]+$)[a-zA-Z0-9\W_!@#$%^&*`~()-+=]{8,64}$/

      if (!this.formInfo.username) {
        this.$layer.msg('用户名不能为空！')
        return false
      } else if (!username.test(this.formInfo.username)) {
        this.$layer.msg('用户名为4-16位数字、字母组合！')
        return
      } else if (!this.formInfo.name) {
        this.$layer.msg('姓名不能为空！')
        return
      } else if (!name.test(this.formInfo.name)) {
        this.$layer.msg('姓名为2-10位中文或4-20位字母！')
        return
      } else if (!this.formInfo.emailInfo) {
        this.$layer.msg('邮箱不能为空！')
        return
      } else if (!email.test(this.formInfo.emailInfo)) {
        this.$layer.msg('邮箱格式有误！')
        return
      } else if (!this.formInfo.password1) {
        this.$layer.msg('请输入密码！')
        return
      } else if (this.formInfo.password1.length < 8) {
        this.$layer.msg('密码必须大于8位！')
        return
      } else if (!this.formInfo.password2) {
        this.$layer.msg('请输入确认密码！')
        return
      } else if (testPassword.test(this.formInfo.password1) === false) {
        this.$layer.msg('密码须同时包含大写字母、小写字母、数字、特殊字符中的任意三种')
        return false
      } else if (this.formInfo.password1 !== this.formInfo.password2) {
        this.$layer.msg('请保持密码一致！')
        return
      } else if (!parseInt(this.formInfo.role)) {
        this.$layer.msg('请选择身份！')
        return
      } else if (!parseInt(this.formInfo.province)) {
        this.$layer.msg('请选择省份！')
        return
      } else if (!parseInt(this.formInfo.school_id)) {
        this.$layer.msg('请选择学校！')
        return
      } else if (parseInt(this.formInfo.role) === 12 && !this.formInfo.s_no) {
        this.$layer.msg('请输入学号！')
        return
      }

      const newFormInfo = JSON.parse(JSON.stringify(this.formInfo))

      if (parseInt(this.formInfo.role) === 11) {
        newFormInfo.major_id = null
      }
      if (Number(this.formInfo.academy_id) === 0) {
        newFormInfo.academy_id = null
      }
      if (Number(this.formInfo.major_id) === 0) {
        newFormInfo.major_id = null
      }
      newFormInfo.password1 = this.utils.encryptDes(newFormInfo.password1)
      newFormInfo.password2 = this.utils.encryptDes(newFormInfo.password2)
      newFormInfo.client_id = this.client_id

      await this.$http.post('/user_register/', newFormInfo).then((data) => {
        if (data.code === '200') {
          this.$layer.msg(data.msg)
          this.$router.push('/login')
        } else {
          this.$layer.msg(data.msg)
        }
      }).catch((error) => {
        this.$layer.msg('注册失败！')
        console.dir(error)
      })
    },
    async getVerifyCode() {
      await this.$http.get('/login_code/', {
        params: {
          client_id: this.client_id
        }
      }).then(async (data) => {
        this.verify.path = data.path
        this.verify.show = true
      }).catch((error) => {
        console.log(error)
      })
    },
    formatImage (path) {
      return this.$store.state.rootUrl + path
    },
    async sendMsg() {
      var mobile = /^1[3456789]\d{9}$/ // 手机号
      if (this.isMsgSend === true) {
        return
      } else if (!this.formInfo.mobile) {
        this.$layer.msg('手机号不能为空！')
        return
      } else if (!mobile.test(this.formInfo.mobile)) {
        this.$layer.msg('手机号格式有误！')
        return
      }

      await this.$http.get('/send_mobile/', {
        params: {
          client_id: this.client_id,
          mobile: this.formInfo.mobile,
          template: 'SMS_238155691'
        }
      }).then((data) => {
        this.$layer.msg('验证码已发送，有效期两分钟！')
        this.smsVerifyCode = data.data
        this.isMsgSend = true
        this.seconds = 120
        this.interval = setInterval(() => {
          if (this.seconds === 0) {
            clearInterval(this.interval)
            this.isMsgSend = false
          }
          this.seconds -= 1
        }, 1000)
      }).catch(() => {
        this.$parent.showMsg('发送验证码失败！')
      })
    },
    async nextStep() {
      var mobile = /^1[3456789]\d{9}$/ // 手机号
      if (!this.isAgree) {
        this.$layer.msg('您需要仔细阅读协议并勾选同意')
        return
      }
      if (!this.formInfo.mobile) {
        this.$layer.msg('手机号不能为空！')
        return
      } else if (!mobile.test(this.formInfo.mobile)) {
        this.$layer.msg('手机号格式有误！')
        return
      } else if (this.verify.show && !this.verifyCode.code) {
        this.$layer.msg('请输入图形验证码！')
        return
      } else if (!this.formInfo.mobile_code) {
        this.$layer.msg('请输入短信验证码！')
        return
      }

      const ckData = await this.$http.post('/login_code/', {
        client_id: this.client_id,
        code: this.verifyCode.code
      })

      if (ckData.code !== '200') {
        this.$layer.msg(ckData.msg)
        return
      }

      const checkMobileCode = await this.$http.post('/send_mobile/', {
        client_id: this.client_id,
        code: this.formInfo.mobile_code
      })
      if (checkMobileCode.code !== '200') {
        this.$layer.msg(checkMobileCode.msg)
        return
      }

      const ckMobile = await this.$http.post('/mobile_check/', {
        mobile: this.formInfo.mobile
      })
      if (ckMobile.code !== '200') {
        this.$layer.msg(ckMobile.msg)
        return
      }

      this.step = '2'
    }
  },
  mounted() {
    this.client_id = uuid.v1()
    this.searchSchool(this.formInfo.province)
    this.getVerifyCode()
  },
  computed: {
    provinceData() {
      return this.$store.state.dict_province
    }
  }
}
</script>

<style lang="less" scoped>
.login {
  margin: 40px auto;
  padding: 40px;
  width: 540px;
  -webkit-border-radius: 5px;
  -moz-border-radius: 5px;
  border-radius: 5px;
  background: #fff;
  box-sizing: border-box;
}

.login_title {
  color: #000;
  font-size: 19px;
  text-align: center;
  padding-bottom: 20px;
}

.login_item {
  margin: 0px;
  margin-top: 20px;
  position: relative;
  border: 1px solid #c9c9c9;
  -webkit-border-radius: 3px;
  -moz-border-radius: 3px;
  border-radius: 3px;
  box-sizing: border-box;
}

.ipt,
select {
  width: 100%;
  padding: 0 20px;
  height: 50px;
  line-height: 50px;
  border: none;
  background: none;
  color: #333;
  font-size: 16px;
  box-sizing: border-box;
}

.login_remenber_box {
  margin: 20px 0;
}

.login_btn {
  width: 100%;
  margin: 20px auto;
  height: 45px;
  line-height: 45px;
  text-align: center;
  color: #fff;
  background: #73D6CA;
  -webkit-border-radius: 3px;
  -moz-border-radius: 3px;
  border-radius: 3px;
  cursor: pointer;
  font-size: 18px;
}
.item-verify {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.code {
  background: #73D6CA;
  display: block;
  width: 120px;
  height: 52px;
  color: #fff;
  line-height: 52px;
  text-align: center;
  cursor: pointer;
}
#content {
  min-height: calc(100vh - 285px);
  padding-top: 40px;
  box-sizing: border-box;
}
.agreement {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  color: #666;
  input {
    margin-right: 5px;
  }
  span {
    color: #73D6CA;
    cursor: pointer;
  }
}
.form_content {
  p {
    color: #333;
    text-indent: 2em;
  }
  .introduction {
    font-weight: bold;
    text-indent: 0;
    margin: 10px 0;
    text-align: center;
  }
  .title {
    font-weight: bold;
    text-indent: 0;
    margin: 10px 0;
  }
}
.form_control {
  padding: 0;
  display: flex;
  justify-content: center;
}
.form_panel {
  max-height: 75%;
}
</style>
